import React, { useId, useState } from "react";

/**
 * A collapsed-by-default intro card.
 *
 * Replaces the old standalone "Landing" tabs: the welcome copy still lives on the
 * page, but it sits above the live content instead of in front of it, so nobody
 * lands on a wall of static text and leaves.
 */
function CollapsibleIntro({ heading, teaser, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <div className="rounded-[12px] bg-dupontBlue/5 dark:bg-darkGold/[0.06] border border-dupontBlue/20 dark:border-darkGold/10 px-[32px] py-[28px] text-center">
      <h2 className="text-[24px] font-display font-bold text-dupontBlue dark:text-dupontGold mb-[8px]">
        {heading}
      </h2>
      <p className="text-[16px] font-body text-dupontGray dark:text-darkTextSecondary leading-relaxed">
        {teaser}
      </p>

      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={panelId}
        className="mt-[12px] inline-flex items-center gap-x-[6px] text-[14px] font-display font-semibold text-dupontBlue dark:text-dupontGold hover:opacity-75 transition-opacity duration-200"
      >
        <span
          className="text-[10px] transition-transform duration-200"
          style={{
            display: "inline-block",
            transform: open ? "rotate(90deg)" : "rotate(0deg)",
          }}
          aria-hidden="true"
        >
          &#9654;
        </span>
        {/* Underline only the words, thin and gold, clear of the letters (Sam, 2026-09-26). */}
        <span className="underline decoration-1 decoration-dupontGold/70 underline-offset-[5px]">
          {open ? "Show less" : "Read more"}
        </span>
      </button>

      {open && (
        <div
          id={panelId}
          className="mt-[20px] pt-[20px] border-t border-dupontBlue/15 dark:border-darkGold/10 flex flex-col gap-y-[16px] text-left max-w-[820px] mx-auto"
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleIntro;
